<template>
  <div class="row shadow-none">
    <div class="col">
      <div :class="['be-loading', { 'be-loading-active': isBusy }]">
        <div
          class="flex flex-col md:flex-row md:justify-between md:items-center gap-[10px] md:gap-0 mb-2"
        >
          <div class="flex flex-col gap-[16px]">
            <button
              class="text-[14px] font-semibold leading-[20px] cursor-pointer focus:outline-none py-[5px] border-b-2 border-[#2463EB] text-[#2463EB] max-w-max"
            >
              Discounts
            </button>
            <p class="text-[#353535] text-[14px] leading-[20px] font-semibold">
              Manage All Discounts here
            </p>
          </div>
          <div>
            <button
              @click="viewAdd"
              class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none max-w-max w-full"
              v-if="hasPermission('Discount_Create')"
            >
              <i class="feather icon-plus"></i> &nbsp;New Discounts
            </button>
          </div>
        </div>
        <div class="">
          <div class="table-responsive">
            <table class="table m-0 p-0 dataTable text-nowrap">
              <thead class="bg-white">
                <tr>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Name
                  </th>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Status
                  </th>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Parent
                  </th>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Created
                  </th>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white">
                <tr v-if="loading">
                  <td colspan="12" class="text-center">
                    <div
                      class="text-center"
                      style="padding-top: 100px; padding-bottom: 50px"
                    >
                      <span
                        class="fa-solid fa-spinner fa-spin text-[#2463EB]"
                        style="font-size: 8rem"
                      ></span>
                      <h3
                        class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                        style="padding-bottom: 100px"
                      >
                        Please wait while we load your distributor's list
                      </h3>
                    </div>
                  </td>
                </tr>
                <tr v-for="d in Discounts" :key="d.id" v-else>
                  <td
                    class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                  >
                    {{ d.name }}
                  </td>
                  <td>
                    <span
                      class="flex items-center gap-[4px] max-w-max w-full"
                      :class="[
                        'badge',
                        {
                          'badge-success': d.active,
                          'badge-danger': !d.active,
                        },
                      ]"
                    >
                      <span
                        class="w-[10px] h-[10px] rounded-[1px]"
                        :style="{
                          backgroundColor: d.active ? '#16a249' : '#EF5253',
                        }"
                      ></span>
                      <span class="text-[12px] font-normal leading-[16.94px]">{{
                        d.active ? "Active" : "Inactive"
                      }}</span>
                    </span>
                  </td>
                  <td
                    class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                  >
                    {{ d.parent ? d.parent.name : "System" }}
                  </td>
                  <td
                    class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                  >
                    {{ formatDate(d.created) }}
                  </td>
                  <td>
                    <div class="dropdown">
                      <button
                        class="btn-no-border"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <span
                          class="text-[#98a2b3] dropdown text-2xl cursor-pointer relative outline-none active:outline-none shadow-none"
                        >
                          ...
                        </span>
                      </button>
                      <ul
                        class="dropdown-menu shadow-none"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <li
                          v-if="hasPermission('Discount_View_Members')"
                          class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[10px] px-[16px] border-b"
                          @click.prevent="viewMembers(d)"
                        >
                          View Member
                        </li>
                        <li
                          v-if="hasPermission('Discount_Update')"
                          class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[10px] px-[16px] border-b"
                          @click="viewEdit(d)"
                        >
                          Edit
                        </li>
                        <!-- <li
                          class="text-[14px] font-normal leading-[20px] text-[#DC2828] cursor-pointer py-[10px] px-[16px]"
                        >
                          Delete
                        </li> -->
                      </ul>
                    </div>
                  </td>
                </tr>
                <tr v-if="!Discounts.length && !loading">
                  <td colspan="10">
                    <div class="text-center" style="padding-top: 50px">
                      <span
                        style="font-size: 4.615rem"
                        class="mdi mdi-basket"
                      ></span>
                    </div>
                    <h3 class="text-center" style="padding-bottom: 100px">
                      No matching records
                    </h3>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination
              :limit="pageSize"
              :count="pageCount"
              :page="page"
              :itemsCount="count"
              @changePage="gotoPage"
              @changeLimit="changeLimit"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="mod-add" role="dialog">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] h-[100dvh]"
        >
          <div class="modal-header- flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
            >
              Create new discount
            </h4>
            <button
              class="text-2xl text-[#353535] outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Name</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v1.name }]"
                  type="text"
                  v-model="createDiscount.name"
                  placeholder="Enter discount name"
                />
                <ul v-if="v1.name" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="flex items-start gap-[16px] w-full pb-[16px]">
              <div class="w-1/2">
                <label
                  class="text-[#353535] font-medium text-[14px] leading-[20px]"
                  >Discount Type</label
                >
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v1.type }]"
                  v-model="createDiscount.type"
                >
                  <option v-for="type in types" :key="type" :value="type">{{
                    type
                  }}</option>
                </select>
                <ul v-if="v1.type" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
              <div class="w-1/2">
                <label
                  class="text-[#353535] font-medium text-[14px] leading-[20px]"
                  >Discount Value</label
                >
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v1.value }]"
                  type="number"
                  v-model="createDiscount.value"
                  placeholder="Enter Value here"
                />
                <ul v-if="v1.value" class="parsley-errors-list filled">
                  <li class="parsley-required">Enter a number > 0.</li>
                </ul>
              </div>
            </div>
            <div
              class="flex items-center gap-[10px] max-w-max"
              @click="createDiscount.active = !createDiscount.active"
            >
              <button
                type="button"
                class="relative inline-flex items-center flex-shrink-0 h-[24px] px-[3px] w-[46px] transition-all duration-200 ease-in-out border-[0.5px] border-[#E4E4E7] shadow-sm rounded-[10px] cursor-pointer w-11 focus:outline-none"
                role="switch"
                :aria-checked="createDiscount.active"
                :class="{
                  'bg-[#2463eb]': createDiscount.active,
                  'bg-[#E4E4E7]': !createDiscount.active,
                }"
              >
                <span
                  aria-hidden="true"
                  class="inline-block w-[21px] h-[16px] bg-white transition duration-200 ease-in-out transform bg-gray-400 rounded-full pointer-events-none"
                  :class="{
                    'translate-x-5 bg-white': createDiscount.active,
                    'translate-x-0 bg-gray-400': !createDiscount.active,
                  }"
                ></span>
              </button>
              <span class="cursor-pointer">
                <span
                  class="text-[#353535] text-[16px] font-normal leading-[20px]"
                >
                  This discount is active
                </span>
              </span>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[48px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              :disabled="isBusyModal"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click.prevent="create"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Add discount</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="mod-edit" role="dialog">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] h-[100dvh]"
        >
          <div class="modal-header- flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
            >
              Edit discount
            </h4>
            <button
              class="text-2xl text-[#353535] outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Name</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v2.name }]"
                  type="text"
                  v-model="updateDiscount.name"
                />
                <ul v-if="v2.name" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="flex items-start gap-[16px] w-full pb-[16px]">
              <div class="w-[1/2]">
                <label
                  class="text-[#353535] font-medium text-[14px] leading-[20px]"
                  >Discount Type</label
                >
                <div>
                  <select
                    class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                    :class="[{ 'is-invalid': v2.type }]"
                    v-model="updateDiscount.type"
                  >
                    <option v-for="type in types" :key="type" :value="type">{{
                      type
                    }}</option>
                  </select>
                  <ul v-if="v2.type" class="parsley-errors-list filled">
                    <li class="parsley-required">Required.</li>
                  </ul>
                </div>
              </div>
              <div class="w-1/2">
                <label
                  class="text-[#353535] font-medium text-[14px] leading-[20px]"
                  >Discount Value</label
                >
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v2.value }]"
                  type="number"
                  v-model="updateDiscount.value"
                  placeholder="Enter Value here"
                />
                <ul v-if="v2.value" class="parsley-errors-list filled">
                  <li class="parsley-required">Enter a number > 0.</li>
                </ul>
              </div>
            </div>
            <div
              class="flex items-center gap-[10px] max-w-max"
              @click="updateDiscount.active = !updateDiscount.active"
            >
              <button
                type="button"
                class="relative inline-flex items-center flex-shrink-0 h-[24px] px-[3px] w-[46px] transition-all duration-200 ease-in-out border-[0.5px] border-[#E4E4E7] shadow-sm rounded-[10px] cursor-pointer w-11 focus:outline-none"
                role="switch"
                :aria-checked="updateDiscount.active"
                :class="{
                  'bg-[#2463eb]': updateDiscount.active,
                  'bg-[#E4E4E7]': !updateDiscount.active,
                }"
              >
                <span
                  aria-hidden="true"
                  class="inline-block w-[21px] h-[16px] bg-white transition duration-200 ease-in-out transform bg-gray-400 rounded-full pointer-events-none"
                  :class="{
                    'translate-x-5 bg-white': updateDiscount.active,
                    'translate-x-0 bg-gray-400': !updateDiscount.active,
                  }"
                ></span>
              </button>
              <span class="cursor-pointer">
                <span
                  class="text-[#353535] text-[16px] font-normal leading-[20px]"
                >
                  This discount is active
                </span>
              </span>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[48px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              :disabled="isBusyModal"
              type="button"
              @click.prevent="update"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Update</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade colored-header colored-header-primary"
      id="mod-filter"
      role="dialog"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header modal-header-colored">
            <h3 class="modal-title">Filter</h3>
            <button
              class="close md-close"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body"></div>
          <div class="modal-footer">
            <button
              style="width: 100px;"
              class="btn btn-secondary md-close"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              style="width: 100px;"
              class="btn btn-secondary md-close"
              type="button"
            >
              Reset
            </button>
            <button
              style="width: 100px;"
              class="btn btn-primary md-close"
              type="button"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
    <DiscountModal
      v-if="isModalVisible"
      :closeModal="closeModal"
      :discountId="DiscountId"
    />
  </div>
</template>

<script>
/* eslint-disable */

import moment from "moment";
import { helper } from "@/helper";
import SystemPermissions from "@/permissions";
import Pagination from "../components/Pagination.vue";
import DiscountModal from "../components/Settings/DiscountModal.vue";

export default {
  mixins: [SystemPermissions.Mixin],
  name: "settingsDiscounts",

  components: {
    Pagination,
    DiscountModal,
  },

  created() {
    if (!this.hasPermission("Discount_View")) {
      this.$router.push("/restricted");
    }
    this.getDiscounts();
    this.getTypes();
  },
  data() {
    return {
      isBusy: false,
      loading: false,
      isBusyModal: false,
      createDiscount: {
        name: null,
        type: null,
        value: null,
        active: false,
        parentId: null,
      },
      updateDiscount: {
        name: null,
        type: null,
        value: null,
        active: false,
        id: null,
      },
      v1: {
        name: false,
        type: false,
        value: false,
      },
      v2: {
        name: false,
        type: false,
        value: false,
      },
      Discounts: [],
      types: [],
      count: 0,
      page: 1,
      pageSize: 10,
      pageCount: 0,
      hasNext: false,
      hasPrev: false,
      isModalVisible: false,
      DiscountId: "",
    };
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
  },
  methods: {
    viewMembers(d) {
      this.DiscountId = d.id;
      this.isModalVisible = true;
      document.body.style.overflow = "hidden";
    },
    closeModal() {
      this.isModalVisible = false;
      document.body.style.overflow = "auto";
    },
    viewAdd() {
      this.createDiscount = {
        name: null,
        type: "Percent",
        value: null,
        active: false,
        parentId: null,
      };
      this.v1 = {
        name: false,
        type: false,
        value: false,
      };

      $("#mod-add").modal("show");
    },
    viewEdit(d) {
      this.updateDiscount = d;
      $("#mod-edit").modal("show");
    },
    viewFilter() {
      $("#mod-filter").modal("show");
    },
    create() {
      this.isBusyModal = true;
      this.isBusy = true;

      let data = {
        name: this.createDiscount.name,
        type: this.createDiscount.type,
        value: this.createDiscount.value,
        active: this.createDiscount.active,
        parentId: this.user.parentId,
      };

      if (this.validateCreate()) {
        $("#mod-add").modal("hide");

        this.$http
          .post("/Discounts/create", data)
          .then(function(res) {
            this.isBusyModal = false;
            this.getDiscounts();
          })
          .catch(function() {
            this.isBusyModal = false;
          });
      } else {
        this.isBusy = false;
        this.isBusyModal = false;
      }
    },
    validateCreate() {
      this.v1 = {
        name: false,
        type: false,
        value: false,
      };
      let isValid = true;

      if (!this.createDiscount.name) {
        this.v1.name = true;
        isValid = false;
      }

      if (!this.createDiscount.type) {
        this.v1.type = true;
        isValid = false;
      }

      if (Number(this.createDiscount.value) <= 0) {
        this.v1.value = true;
        isValid = false;
      }

      return isValid;
    },
    update() {
      this.isBusyModal = true;
      this.isBusy = true;

      let data = {
        name: this.updateDiscount.name,
        type: this.updateDiscount.type,
        value: this.updateDiscount.value,
        active: this.updateDiscount.active,
        id: this.updateDiscount.id,
      };

      if (this.validateUpdate()) {
        $("#mod-edit").modal("hide");

        this.$http
          .put("/Discounts/update/" + data.id, data)
          .then(function(res) {
            this.isBusyModal = false;
            this.getDiscounts();
          })
          .catch(function() {
            this.isBusy = false;
            this.isBusyModal = false;
          });
      } else {
        this.isBusy = false;
        this.isBusyModal = false;
      }
    },
    validateUpdate() {
      this.v2 = {
        name: false,
        type: false,
        value: false,
      };
      let isValid = true;

      if (!this.updateDiscount.name) {
        this.v2.name = true;
        isValid = false;
      }

      if (!this.updateDiscount.type) {
        this.v2.type = true;
        isValid = false;
      }

      if (Number(this.updateDiscount.value) <= 0) {
        this.v2.value = true;
        isValid = false;
      }

      return isValid;
    },
    getDiscounts() {
      this.isBusy = true;
      this.loading = true;
      this.$http
        .get(
          "/Discounts/getList?page=" +
            (this.page - 1) +
            "&pageSize=" +
            this.pageSize +
            (this.user.parentId ? "&parentId=" + this.user.parentId : "")
        )
        .then(function(res) {
          this.Discounts = res.body.data;
          this.page = res.body.page + 1;
          this.pageSize = res.body.pageSize;
          this.count = res.body.count;
          this.pageCount = Math.ceil(res.body.count / res.body.pageSize);
          this.hasPrev = res.body.hasPrev;
          this.hasNext = res.body.hasNext;
          this.isBusy = false;
          this.loading = false;
        })
        .catch(function() {
          this.isBusy = false;
          this.loading = false;
        });
    },
    getTypes() {
      this.types = ["Percent", "Amount"];
    },
    formatDate(date) {
      return moment(date).format("ll");
    },
    prev() {
      this.page -= 1;
      this.getDiscounts();
    },
    next() {
      this.page += 1;
      this.getDiscounts();
    },

    gotoPage(page) {
      this.page = page;
      this.getDiscounts();
    },

    changeLimit(limit) {
      this.pageSize = limit;
      this.getDiscounts();
    },
  },
};
</script>
